export default "__VITE_ASSET__Br$fEQN4__"